import { render, staticRenderFns } from "./RecommendationOrderModal.vue?vue&type=template&id=57516954"
import script from "./RecommendationOrderModal.vue?vue&type=script&lang=js"
export * from "./RecommendationOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports